import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=dbaf4188&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=ts&"
export * from "./ProductList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=dbaf4188&prod&scoped=true&lang=sass&"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=dbaf4188&prod&scoped=true&lang=css&"
import style2 from "./ProductList.vue?vue&type=style&index=2&id=dbaf4188&prod&lang=sass&scoped=true&"
import style3 from "./ProductList.vue?vue&type=style&index=3&id=dbaf4188&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaf4188",
  null
  
)

export default component.exports